// extracted by mini-css-extract-plugin
export default {"wrapper":"tabs_wrapper__x6Cfu","item":"tabs_item__seQBj","selected":"tabs_selected__VWtji"};